module.exports = __webpack_public_path__ + "img/shift-alert.a4edae08.webp";